import React, { useCallback } from "react";
import { NumberInput, TextInput } from "react-admin";
import { useFormContext } from "react-hook-form";

const onWheel = (e) => e.target.blur();

export const withDisableOnWheel = (WrapComp) => (props) =>
  <WrapComp {...props} onWheel={onWheel} type="number" />;

const withDisableOnWheelDecimal = (WrapComp) => (props) =>
  (
    <WrapComp
      {...props}
      onWheel={onWheel}
      inputProps={{
        ...(props.inputProps || {}),
        type: "number",
        step: "0.01",
      }}
    />
  );

export const withValidateOnKeyPress = (WrapComp) => (props) => {
  const { onKeyPress, ...otherProps } = props;
  const { trigger } = useFormContext();

  const handler = useCallback(
    async (e) => {
      if (typeof onKeyPress === "function") {
        const valid = await trigger();
        if (valid) onKeyPress(e);
      }
    },
    [onKeyPress, trigger]
  );

  return <WrapComp {...otherProps} onKeyPress={handler} />;
};

export default withDisableOnWheelDecimal(TextInput);
